import { Checkbox, FormControlLabel, Stack } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

interface CheckboxGroupFieldProps {
  name: string;
  options: { label: string; value: string }[];
}

const CheckboxGroupField = ({ name, options }: CheckboxGroupFieldProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        const fieldValue = Array.isArray(field.value) ? field.value as string[] : [];    
        return (
          <Stack>
            {options.map((opt) => (
              <FormControlLabel
                key={opt.value}
                control={
                  <Checkbox
                    checked={fieldValue.includes(opt.value)}
                    onChange={(_e, checked) => {
                      const current = fieldValue;
                      const newValue = checked
                        ? [...current, opt.value]
                        : current.filter((v: string) => v !== opt.value);
                      field.onChange(newValue);
                    }}
                  />
                }
                label={opt.label}
              />
            ))}
          </Stack>
        );
      }}
    />
  );
};

export default CheckboxGroupField;
